import { Button, ButtonIconWithLabel, Icon_OpenNew24, PlatformAPI } from "@shapr3d/frontend-lib";

import { ProjectUserRole, useProject } from "../../hooks/useProject";
import { useDeepLinkStateStore } from "../../stores/deepLinkStateStore";
import useTracker from "../../utils/useTracker";

export const DeepLinkButton = () => {
  const tracker = useTracker();

  const { setIsModalOpen } = useDeepLinkStateStore();
  const { data: projectData } = useProject();
  if (
    !PlatformAPI.getInstance().isShaprSupportedPlatform() ||
    projectData?.userRole !== ProjectUserRole.Owner
  ) {
    return null;
  }

  return (
    <Button
      variant="grayscale"
      onClick={() => {
        tracker.trackDeeplinkButtonClicked({ projectId: projectData.project.projectId });
        setIsModalOpen(true);
      }}
    >
      <ButtonIconWithLabel icon={<Icon_OpenNew24 />} label="Open in Shapr3D app" />
    </Button>
  );
};
